<template>
  <b-button
    class="main-outlinebutton"
    :style="isLaptop ? 'width: 240px;' : 'width: 170px;'"
    :class="type == 'arrow' ? 'd-flex align-items-center gap-3 width-50' : ''"
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    @click="$emit('clicked')"
  >
    <span>{{ text }}</span>

    <img
      v-if="type == 'arrow'"
      :src="hovered ? hoveredArrow : whiteArrow"
      alt="arrow"
    />
  </b-button>
</template>
<script>
import whiteArrow from "@/assets/imgs/homepage/white-arrow.svg";
import hoveredArrow from "@/assets/imgs/homepage/hovered-right-arrow.svg";

export default {
  name: "OutlineButton",
  props: {
    text: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLaptop: true,
      hovered: false,
      whiteArrow,
      hoveredArrow,
    };
  },
  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
  },
  methods: {
    checkScreenSize() {
      this.isLaptop = window.innerWidth >= 1024;
    },
  },
};
</script>

<style>
.main-outlinebutton {
  border-radius: 50px;
  color: #fbfbfb;
  font-weight: 800;
  background-color: transparent;
  font-family: "Inter", serif;
  font-size: 16px;
  border: 1px solid #fff;
  display: inline-flex;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
}

.main-outlinebutton:focus {
  border-radius: 50px;
  color: #fbfbfb;
  background-color: transparent;

  border: 1px solid #fff;
  box-shadow: unset;
}

.main-outlinebutton:hover {
  border-radius: 50px;
  color: #2e425d;
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.main-outlinebutton:disabled {
  border-radius: 50px;
  color: #fbfbfb;
  border: 1px solid #fff;
  opacity: 0.5;
}

.main-outlinebutton.btn-secondary:not(:disabled):not(.disabled):active {
  border-radius: 50px;
  color: #2e425d;
  border: 1px solid #fff;
  background-color: #fff;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}

@media screen and (max-width: 1028px) {
  .main-outlinebutton {
    font-size: 13px;
    gap: 5px !important;
  }
  .width-50 {
    width: 50% !important;
  }
  .home-business-btn .width-50 {
    width: 100% !important;
  }
}
</style>
